module.exports = __webpack_public_path__ + "static/media/hdi-noneOption.71770855.svg";